module.exports = __webpack_public_path__ + "img/checkpoints.99d01520.png";